// TDS Sections under Indian Income Tax Act
export const TDS_SECTIONS = [
  { section: '192', name: 'Salaries', defaultRate: null },
  { section: '192A', name: "Premature taxable withdrawal from Employees' Provident Fund (EPF)", defaultRate: null },
  { section: '193', name: 'Interest on securities', defaultRate: null },
  { section: '194', name: 'Dividends', defaultRate: null },
  { section: '194A', name: 'Interest other than interest on securities (e.g., Bank FDs, loans)', defaultRate: null },
  { section: '194B', name: 'Winnings from lotteries, crossword puzzles, card games, or betting', defaultRate: 30 },
  { section: '194BA', name: 'Net winnings from online games', defaultRate: 30 },
  { section: '194BB', name: 'Winnings from horse races', defaultRate: 30 },
  { section: '194C', name: 'Payments to contractors and sub-contractors (works contracts)', defaultRate: 2 },
  { section: '194D', name: 'Insurance commission', defaultRate: 5 },
  { section: '194DA', name: 'Payment in respect of life insurance policy', defaultRate: 5 },
  { section: '194E', name: 'Payments to non-resident sportsmen or sports associations', defaultRate: 20 },
  { section: '194EE', name: 'Payments out of deposits under the National Savings Scheme (NSS)', defaultRate: 10 },
  { section: '194G', name: 'Commission on sale of lottery tickets', defaultRate: 5 },
  { section: '194H', name: 'Commission or brokerage', defaultRate: 5 },
  { section: '194-I', name: 'Rent (land, building, plant, machinery, or equipment)', defaultRate: 10 },
  { section: '194-IA', name: 'Payment on transfer of immovable property (other than agricultural land)', defaultRate: 1 },
  { section: '194-IB', name: 'Rent paid by individuals or HUFs not subject to tax audit', defaultRate: 5 },
  { section: '194-IC', name: 'Monetary consideration under a Joint Development Agreement (JDA)', defaultRate: 10 },
  { section: '194J', name: "Fees for professional services, technical services, royalty, or director's remuneration", defaultRate: 2 },
  { section: '194LA', name: 'Compensation on compulsory acquisition of immovable property', defaultRate: 10 },
  { section: '194M', name: 'Payments to contractors/professionals by individuals or HUFs not covered under 194C/194J', defaultRate: 5 },
  { section: '194N', name: 'Cash withdrawals exceeding specified limits from banks or post offices', defaultRate: 2 },
  { section: '194-O', name: 'Payment or credit by e-commerce operators to e-commerce participants', defaultRate: 1 },
  { section: '194P', name: 'Deduction of tax by specified banks in respect of senior citizens aged 75 or above', defaultRate: null },
  { section: '194Q', name: 'Payment for purchase of goods', defaultRate: 0.1 },
  { section: '194R', name: 'Benefit or perquisite arising from business or exercise of a profession', defaultRate: 10 },
  { section: '194S', name: 'Consideration for transfer of Virtual Digital Assets (cryptocurrency/NFTs)', defaultRate: 1 },
  { section: '194T', name: 'Salary, remuneration, commission, bonus, or interest paid to a partner of a firm', defaultRate: 10 },
  { section: '195', name: 'Payments of other sums (income) to a non-resident or foreign company', defaultRate: null }
];

export const findTdsSection = (sectionCode) => {
  if (!sectionCode) return null;
  const clean = String(sectionCode).trim().toLowerCase();
  return TDS_SECTIONS.find(s => s.section.toLowerCase() === clean);
};

export const formatTdsSectionLabel = (sectionCode) => {
  if (!sectionCode) return '';
  const item = findTdsSection(sectionCode);
  return item ? `Sec ${item.section} (${item.name})` : `Sec ${sectionCode}`;
};
